export default {
  InventoryPlaceholder: 'InventoryPlaceholder',
  Inventory: 'Inventory',
  InventoryRoot: 'InventoryRoot',
  LotBreakdown: 'LotBreakdown',
  LotBreakdownByStatus: 'LotBreakdownByStatus',
  ExportInventory: 'ExportInventory'
}
